import { TranslatedComponent } from 'bloko/common/hooks/useTranslations';

import translation from 'src/components/translation';
import { useSelector } from 'src/hooks/useSelector';

import CatalogLinks from 'src/components/CatalogSearch/CatalogLinks';

const TrlKeys = {
    header: 'seo_catalog.extra_filters.title',
};

const ExtraFilters: TranslatedComponent = ({ trls }) => {
    const extraFilters = useSelector((state) => state.extraFilters);

    if (extraFilters.length === 0) {
        return null;
    }

    return (
        <CatalogLinks
            blockDataQa="catalog-search-extra-filters"
            links={extraFilters}
            title={trls[TrlKeys.header]}
            hhtmSourceLabel="BOTTOM_FILTER_CATALOG"
        />
    );
};

export default translation(ExtraFilters);
